import { RegionSelectOption } from 'interfaces/filter';

const Regions: Array<RegionSelectOption> = [
  { name: 'EU', value: 'EU' },
  { name: 'UK', value: 'UK' },
  { name: 'US', value: 'US' },
  { name: 'CA', value: 'CA' },
  { name: 'NZ', value: 'NZ' },
  { name: 'AU', value: 'AU' },
  { name: 'BR', value: 'BR' },
  { name: 'MY', value: 'MY' },
  { name: 'CN', value: 'CN' },
  { name: 'MX', value: 'MX' },
  { name: 'ZA', value: 'ZA' },
];

export default Regions;
